var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHeroMobile = function SvgHeroMobile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    viewBox: "0 0 375 412",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M654.4,314.9c-81.5,0.6-101.6-53.6-179.1-53.6C422.7,261.3,375,285,375,285s-50,29.6-95.6,29.9 c-81.5,0.6-101.6-53.6-179.1-53.6C47.7,261.3,0,285,0,285v126.6h375h375V285C750,285,700,314.6,654.4,314.9z"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    values: " M654.4,314.9c-81.5,0.6-101.6-53.6-179.1-53.6C422.7,261.3,375,285,375,285s-50,29.6-95.6,29.9c-81.5,0.6-101.6-53.6-179.1-53.6C47.7,261.3,0,285,0,285v126.6h375h375V285C750,285,700,314.6,654.4,314.9z; M654.4,253.4c-81.5,0.6-101.6,60.5-179.1,60.5C422.7,313.9,375,285,375,285s-50-31.9-95.6-31.6c-81.5,0.6-101.6,60.5-179.1,60.5C47.7,313.9,0,285,0,285v126.6h375h375V285C750,285,700,253.1,654.4,253.4z; M654.4,314.9c-81.5,0.6-101.6-53.6-179.1-53.6C422.7,261.3,375,285,375,285s-50,29.6-95.6,29.9c-81.5,0.6-101.6-53.6-179.1-53.6C47.7,261.3,0,285,0,285v126.6h375h375V285C750,285,700,314.6,654.4,314.9z",
    dur: "15s",
    repeatCount: "indefinite"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeroMobile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Hero-mobile.0b2ae2c6.svg";
export { ForwardRef as ReactComponent };